import React, { useEffect } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { fetchShopping } from '@/actions/shopping';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Main from '@/layouts/Main';
import PageHeader from '@/components/common/PageHeader';
import BottomBanner from '@/components/common/BottomBanner';
import Head from '@/components/common/Head';
import DetailDescription from '@/components/shoppings/DetailDescription';
import DetailButton from '@/components/shoppings/DetailButton';
import DetailAction from '@/components/shoppings/DetailAction';
import ShoppingCommentTimelineContainer from '@/containers/shoppings/ShoppingCommentTimelineContainer';
import ShoppingCommentPostContainer from '@/containers/shoppings/ShoppingCommentPostContainer';
import DetailImageContainer from '@/containers/shoppings/DetailImageContainer';
import DetailTitleContainer from '@/containers/shoppings/DetailTitleContainer';
import ShoppingCarouselList from '@/components/shoppings/ShoppingCarouselList';
import styles from 'styles/jss/original/pages/shoppings/slug';
import { SHOPPING_SAME_CATEGORY } from '@/constants/app';
import { SITE_TITLE, SITE_DESCRIPTION } from '@/config/meta';
import classNames from 'classnames';
import _ from 'lodash';
import { useMedia } from 'react-use';
import basicAuthentication from '@/lib/basicAuthentication';
import useShoppingDetail from '@/hooks/useShoppingDetail';
import { wrapper, AppDispatch } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const ShoppingPost: NextPage = () => {
  const classes = useStyles();
  const isSp = useMedia('(max-width:640px)');
  const [shopping, shoppingList, error] = useShoppingDetail();
  const router = useRouter();
  useEffect(() => {
    if (error) {
      _.defer(() => router.replace('/404'));
    }
  }, [error, router]);
  if (error || !shopping) return null;
  return (
    <div className={classes.productPage}>
      <Main>
        <Head
          title={`${shopping.fields.title} | ${SITE_TITLE}`}
          description={`${shopping.fields.desc} | ${SITE_DESCRIPTION}`}
          image={`https:${shopping.fields.mainImage.fields.file.url}`}
          url={`https://smalldish.jp/shoppings/${shopping.fields.slug}`}
        />
        <PageHeader type='shoppingDetail' />
        <div className={classes.section}>
          <div className={classes.container}>
            <div className={classNames(classes.main, classes.mainRaised)}>
              <GridContainer>
                {/* @ts-expect-error */}
                <GridItem xs={12} sm={12} md={6}>
                  <DetailImageContainer shopping={shopping} />
                </GridItem>
                {/* @ts-expect-error */}
                <GridItem xs={12} sm={12} md={6}>
                  <DetailTitleContainer shopping={shopping} />
                  <DetailDescription shopping={shopping} />
                  {!isSp && <DetailButton shopping={shopping} />}
                </GridItem>
              </GridContainer>
            </div>
            <ShoppingCommentTimelineContainer shopping={shopping} />
            <ShoppingCommentPostContainer shopping={shopping} />
            <ShoppingCarouselList title={SHOPPING_SAME_CATEGORY} shoppingList={shoppingList} />
          </div>
          <BottomBanner />
        </div>
        {isSp && <DetailAction shopping={shopping} />}
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ query, store, req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
  await (store.dispatch as AppDispatch)(fetchShopping(query.slug));
});

export default ShoppingPost;
